import React from 'react'

function ReportPrint() {
    return (
        <div><h1>Exported Data</h1>
            <div>
                <div className='table'>
                    {/* <table class="table">
                        <thead>
                            <tr className='tr-heading'>
                                <th>S.No</th>
                                <th>Invoice No.</th>
                                <th>Client Name</th>
                                <th>Date</th>
                                <th>Due Date</th>
                                <th>Notes</th>
                                <th>Total Amount</th>


                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((data, index) => (
                                <tr key={index} className="tr-shadow">
                                    <td>{index + 1}</td>
                                    <td>{data.invoiceId}</td>
                                    <td>{data.clientName}</td>
                                    <td>{data.date}</td>
                                    <td>{data.dueDate}</td>
                                    <td>{data.notes}</td>
                                    <td>{data.totalAmount}</td>


                                </tr>
                            ))}
                        </tbody>

                    </table> */}
                </div>
            </div>
        </div>
    )
}

export default ReportPrint;